import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Form } from "react-final-form";
import * as yup from "yup";
import { Grid } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import FormHelperText from "@mui/material/FormHelperText";
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";

import UiInput from "../../../../../../_uiComponents/UiInput";

import { UiRadioBtn } from "../../../../../../_uiComponents/common/form/UiRadioBtn";

import UiSwitch from "../../../../../../_uiComponents/common/form/UiSwitch";
import MultiSelect from "../../../../../../_uiComponents/common/form/MultiSelect";
import {
     UiButton,
     UiBackButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import UiSelect from "../../../../../../_uiComponents/common/form/UiSelect";
import UiDateRangePicker from "../../../../../../_uiComponents/common/form/UiDateRangePicker";
import HierarchyDataGrid from "../../../HierarchyDataGrid";
import Validator from "../../../../../../../_helpers/validate.schema";
import {
     campaignTypesRequest,
     getCampaignParticipantsRequest,
     getCampaignSalesRequest,
     getCampaignTemplateTypeRequest,
     getCampaignProductRequest,
     participantListRequest,
     creationStepOneRequest,
     getParticipantDataTemplateRequest,
     getSalseDataTemplateRequest,
     updateAboutCampaignStepOneRequest,
     listCampaignParticipantsRequest,
     addCampaignParticipantsRequest,
} from "../../../../../../../_redux/_actions";
import AccordionComponent from "../../../../../../_uiComponents/common/AccordionComponent";
import CampaignAdminGrid from "../CampaignAdminGrid";
import {
     FORM_TYPE_ADD,
     FORM_TYPE_EDIT,
} from "../../../../../../../_helpers/constants";

const validateSchema = () =>
     yup.object().shape({
          participantsList: yup
               .array()
               .min(1, "Select atleast one participant.")
               .required("Select atleast one participant."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function AddParticipantsForm(props) {
     const [participantType, setParticipantType] = useState("all");
     const [expanded, setExpanded] = React.useState(false);

     const actionDispatch = useDispatch();

     const { participantGroups } = useSelector((state) => {
          return {
               participantGroups: state.incentive.participantGroups,
          };
     });

     const submit = async (values) => {
          actionDispatch(
               addCampaignParticipantsRequest({ ...values, id: props.id }),
          );
     };

     const handleChange = (panel) => (event, isExpanded) => {
          setExpanded(isExpanded ? panel : false);
          if (isExpanded) {
               actionDispatch(
                    listCampaignParticipantsRequest({ id: props.id }),
               );
          }
     };

     return (
          <AccordionComponent
               expanded={expanded === "CampaignParticipants"}
               handleChange={handleChange("CampaignParticipants")}
               title="Campaign Participants"
          >
               <Grid container spacing={2}>
                    <Grid item xs={12} lg={12}>
                         <FormControl>
                              <RadioGroup
                                   row
                                   aria-labelledby="demo-row-radio-buttons-group-label"
                                   name="row-radio-buttons-group"
                              >
                                   <UiRadioBtn
                                        checked={"all" == participantType}
                                        onClick={() =>
                                             setParticipantType("all")
                                        }
                                        value="all"
                                        control={<Radio />}
                                        label="All"
                                   />
                                   {participantGroups.map((group, index) => {
                                        return (
                                             <UiRadioBtn
                                                  checked={
                                                       group.code ==
                                                       participantType
                                                  }
                                                  key={index}
                                                  onClick={() =>
                                                       setParticipantType(
                                                            group.code,
                                                       )
                                                  }
                                                  value={group.code}
                                                  control={<Radio />}
                                                  label={group.displayName}
                                             />
                                        );
                                   })}
                              </RadioGroup>
                         </FormControl>
                    </Grid>
                    <Form
                         onSubmit={submit}
                         validate={onValidate}
                         mutators={{
                              setFormAttribute: (
                                   [fieldName, fieldVal],
                                   state,
                                   { changeValue },
                              ) => {
                                   changeValue(
                                        state,
                                        fieldName,
                                        () => fieldVal,
                                   );
                              },
                         }}
                         render={({ form, handleSubmit, ...formValues }) => {
                              return (
                                   <form onSubmit={validateSchema}>
                                        <>
                                             <Grid item xs={12} lg={12}>
                                                  <HierarchyDataGrid
                                                       participantType={
                                                            participantType
                                                       }
                                                       setSelectedParticipant={(
                                                            data,
                                                       ) => {
                                                            form.mutators.setFormAttribute(
                                                                 "participantsList",
                                                                 data,
                                                            );
                                                       }}
                                                  />
                                                  <br />
                                                  {form.getState()
                                                       .submitFailed &&
                                                       formValues.errors
                                                            .participantsList && (
                                                            <FormHelperText className="sba-form-error">
                                                                 {
                                                                      formValues
                                                                           .errors
                                                                           .participantsList
                                                                 }
                                                            </FormHelperText>
                                                       )}
                                             </Grid>

                                             <div className="sba-campaign-content-button">
                                                  <UiButton
                                                       name="Clear"
                                                       variant="outlined"
                                                       size="large"
                                                  />
                                                  <UiButton
                                                       name="Save"
                                                       variant="contained"
                                                       size="large"
                                                       onClick={handleSubmit}
                                                  />
                                             </div>
                                        </>
                                   </form>
                              );
                         }}
                    />
               </Grid>
          </AccordionComponent>
     );
}
